/**
 * streamStore — transient in-memory store for the live MediaStream.
 *
 * Problem: React Router's navigate(..., { state }) serialises the state
 * through history.replaceState. Some browser extensions (PiP, etc.) hook
 * replaceState and attempt to structuredClone the state, which throws
 * DataCloneError for MediaStream objects.
 *
 * Solution: store the stream in a module-level variable that never touches
 * the History API. InstructionsRoute calls storeStream() before navigating;
 * InterviewRoute calls consumeStream() on mount to pick it up.
 * consumeStream() clears the variable immediately so there is no stale ref.
 */

let _pendingStream = null;

/** Store a MediaStream so the next InterviewRoute mount can consume it. */
export function storeStream(stream) {
  _pendingStream = stream;
}

/**
 * Retrieve and clear the pending stream.
 * Returns null if no stream was stored (e.g. direct navigation to /interview/:link).
 */
export function consumeStream() {
  const s = _pendingStream;
  _pendingStream = null;
  return s;
}
